import loadable from "@loadable/component";
import CreateIcon from "../../Icons/CreateIcon";
import APIS from "../../constant/Endpoint";
import usePostHook from "../../customHooks/usePostHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useSearchParams } from "react-router-dom";
import useGetHook from "../../customHooks/useGetHook";
const CreateRiderInvoiceComponent = loadable(
  () => import("../../components/RiderInvoice/CreateRiderInvoice")
);

const CreateRiderInvoice = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["rider-invoice"],
    navigateURL: "/",
  });
  const { data: gridData, isLoading } = useGetHook({
    queryKey: [`grid-data`],
    url: `${APIS.GRID_REPORT_DATA}`,
    params: {
      parent__slug: "rider",
    },
  });
  const { data: statusData } = useGetHook({
    queryKey: [`status`],
    url: `${APIS.ORDER_STATUS}`,
    params: {
      is_final_state: true,
      is_active: true,
    },
  });
  const [searchParams, setSearchParms] = useSearchParams();
  const handleCreate = async (values: any, setError: any) => {
    const selectedOrder = searchParams.get("selectedItems")?.split(",");
    const url = `${APIS.RIDER_INVOICE}`;
    const dates = values?.created__range
      ? values?.created__range
          .split(",")
          .map((datetime) => datetime.split("T")[0])
      : null;
    let formData = {
      user: values,
      orders: selectedOrder,
      date_range: dates,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Rider Statement
        </span>
      </div>
      <CreateRiderInvoiceComponent
        handleCreate={handleCreate}
        isLoading={isPostLoading}
        gridData={gridData}
      />
    </>
  );
};

export default CreateRiderInvoice;
